<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Add / Update In Service Number</v-card-title>

        <v-card-text>

            <v-text-field
                label="Phone Number"
                v-model="endpoint"
                autofocus
                autocomplete="off"
            />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid_number"
            >
            Update
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {

    data() {
        return {
            dialog: false,
            endpoint: null,
            results: null,
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
        },

        onCancel()
        {
            this.dialog = false;
        },

        onOk()
        {
            this.dialog = false;

            this.$rc.showSpinner();
            
            let endpoint = E164.createEndpointFromUSPhoneNumber(this.endpoint,null);

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/numbers/partial-update-in-service',
            
                'params' :  {
                    'endpoints' : [endpoint],
                },
            
                'on_success': (data) => {
                        this.$emit('update',endpoint);
                    },
            
                'on_error': 'Unable to update one incoming number',
            });
        },
    },

    computed: {
        is_valid_number() 
        {
            if ( this.endpoint == null ) return false;
            return E164.createEndpointFromUSPhoneNumber(this.endpoint,null) != null;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>